module.exports = __webpack_public_path__ + "static/media/DSC01510.971b959f.jpg";